import React from 'react';
import {PageTitle} from '../../common/pageTitle/PageTitle';
import {Helmet} from 'react-helmet';
import './ugiCommunicationsPage.scss';

/**
 * The UgiCommunicationsPage component.
 *
 * @constructor
 */
export class UgiCommunicationsPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }


  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="ugi-communications-page" className="system-page">
        <Helmet>
          <title>Communication Utilities - NEI</title>
          <meta name = "description" content ="Telecommunication refers to the process of voice, data, and video communication over a distance, commonly accomplished using both buried cables." />
        </Helmet>
        <div className="container-fluid">
          <div className="row row-odd">
            <div className="container">
              <div className="row">
                <div className="col">
                  <p>Telecommunication refers to the process of voice, data, and video communication over a distance. Although the term includes microwave, cellular, radio, and television transmissions through the air, it is most commonly accomplished using both buried copper and fiber optic cables. Most copper and fiber optic cables are currently capable of “broadband” transmission, meaning they are able to carry a wide band of frequencies or channels at one time. As an example, although there are currently approximately, 150,000 cell towers in the United States there are almost 400,000 miles of buried fiber optic cables, enough to circle the globe 16 times!</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-even">
            <div className="container">
              <div className="row h-100">
                <div className="col my-auto">
                  <h1>Resource Links</h1>
                  <p><a href="https://www.ctia.org/news/new-rules-for-new-wireless-networks" target="_blank" >ctia.org</a></p>
                  <p><a href="http://www.itta.us/" target="_blank">itta.us</a></p>
                  <p><a href="https://www.ncta.com/broadband-by-the-numbers" target="_blank">ncta.com</a></p>
                  <p><a href="https://www.fiberbroadband.org/" target="_blank">fiberbroadband.org</a></p>
                  <p><a href="https://www.ntca.org/" target="_blank">ntca.org</a></p>
                  <p><a href="https://www.ustelecom.org/" target="_blank">ustelecom.org</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UgiCommunicationsPage.propTypes = {};

export default UgiCommunicationsPage;



// WEBPACK FOOTER //
// ./src/components/pages/ugiCommunications/UgiCommunicationsPage.js